// get custom fields data for particular asset

import getJSON from '@api/api_helper';

import { CustomFieldMapsResponse, CreateCustomFieldParams } from './customFieldTypes';

const fetchMutateUrl = (assetKey): string => `/api/v4/assets/${assetKey}/custom_fields`;

export const getCustomFieldMaps = ({ assetKey }: { assetKey: string }, params = {}): Promise<CustomFieldMapsResponse> => {
  const url = `/api/v4/private/assets/${assetKey}/custom_field_maps`;
  return getJSON(url, { params }, () => { /* no op */ });
};

export const createCustomFields = (
  { assetKey, createdCustomFields }: { assetKey: string; createdCustomFields: CreateCustomFieldParams[]},
  params = {}
): Promise<any> => {
  const url = fetchMutateUrl(assetKey);
  const appendedOptions = {
    body: {
      data: {
        attributes: createdCustomFields
      }
    },
    method: 'POST',
    params
  };
  return getJSON(url, appendedOptions);
};
